import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  progress: {
    color: '#bfd730',
    alignSelf: 'center',
    marginBottom: '20px',
  },
  container: {
    minHeight: 'inherit',
    height: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    padding: 20,
    textAlign: 'center'
  },
  message: {
    fontSize: '14px',
    fontWeight: '600',
  }
}));

function Loading({message = '', style}) {
  const styles = useStyles();
  return (
    <section className={styles.container} style={style}>
      <CircularProgress className={styles.progress} size={60} thickness={2}/>
      <div className={styles.message}>{message}</div>
    </section>
  )
}

export default Loading;

Loading.defaultProps = {
  message: '',
  style: {}
}
